export const SMART_REPLY_BUTTON_TEXT = 'Smart Reply';
export const AI_EDITS_BUTTON_TEXT = 'AI edits';
